<div class="placeholders-callout" [class.expanded]="showPlaceholders()">
  <div class="placeholders-header">
    <strong class="placeholders-title" translate="PLACEHOLDERS.TITLE"></strong>
    @if (loaded()) {
      <button type="button" class="toggle-button" (click)="togglePlaceholders()">
        <span [translate]="showPlaceholders() ? 'HIDE' : 'SHOW'"></span>
        <gb-icon [icon]="showPlaceholders() ? 'chevron-up' : 'chevron-down'" height="14px"></gb-icon>
      </button>
    }
  </div>

  <div class="placeholders-body">
    <div class="placeholders-content">
      <span translate="PLACEHOLDERS.DESCRIPTION"></span>
      <div class="placeholders-list">
        @for (placeholder of placeholders(); track placeholder.key; let last = $last) {
          <div class="placeholder-item">
            <code [translate]="placeholder.key"></code>
            <span [translate]="placeholder.description"></span>
          </div>
          @if (!last) {
            <mat-divider></mat-divider>
          }
        }
      </div>
    </div>
  </div>
</div>
